import {
  GET_ACCOUNT_FEATURE_FLAGS,
  GET_ROLES_FOR_USER,
  GET_SCHOOLS_BY_SCHOOL_ID,
  GET_SUBSCRIPTIONS,
  GET_DISTRICT_NAME_BY_ID,
  GET_DISTRICT_BY_SCHOOL_ID
} from './graphql/portal.graphql'
import client from '../client/ApolloPortalBffClient'

export default class PortalBffClientHttp {  
  async getFeatureFlags(){
    try {
      const { data, errors } = await client.query({
        query: GET_ACCOUNT_FEATURE_FLAGS,
        fetchPolicy: 'cache-first',
      })

      if (errors && errors.length > 0) {
        throw errors[0]
      }

      const {
        profile: { featureFlags },
      } = data

      return featureFlags
    } catch (e) {
      return {
        portal_nav: 0,
        portal_nav_banner: 0,
        upload_flyer: 0,
        approval_center: 0,
        approval_center_banner: 0,
        org_uploader: 0,
        managed_services: 0,
        comm_free: 0,
      }
    }
  }

  async getRolesForUser(userId) {
    try {
      const { data } = await client.query({
        query: GET_ROLES_FOR_USER,
        fetchPolicy: 'cache-first',
        errorPolicy: 'all',
        variables: {
          input: {
            userId
          }
        }
      })

      const {
        getRolesForUser
      } = data
      return {
        data: {
          entities: getRolesForUser || []
        }
      }

    } catch (e) {
      return {
        data: {
          entities: []
        }
      }
    }
  }

  async getSchoolBySchoolId(schoolIds){
    try {
      const { data } = await client.query({
        query: GET_SCHOOLS_BY_SCHOOL_ID,
        fetchPolicy: 'cache-first',
        errorPolicy: 'all',
        variables: {
          schoolIds
        }
      })

      const {
        getSchoolsBySchoolId
      } = data

      if (getSchoolsBySchoolId && getSchoolsBySchoolId.items.length > 0) {
        return {
          data: {
            name: getSchoolsBySchoolId.items[0].name,
            success: true
          }
        }
      }
      return {
        data: {
          name: '',
          success: false
        }
      }
    } catch (e) {
      return {
        data: {
          name: '',
          success: false
        }
      }
    }
  }

  async getDistrictIdBySchool(schoolId){
    try {
      const { data } = await client.query({
        query: GET_DISTRICT_BY_SCHOOL_ID,
        fetchPolicy: 'cache-first',
        errorPolicy: 'all',
        variables: {
          input: {
            schoolId: Number(schoolId)
          }
        }
      })

      const {
        getSchool
      } = data
      if (getSchool && getSchool.district.districtId) {
        return {
          data: {
            districtId: getSchool.district.districtId,
            success: true
          }
        }
      }
      return {
        data: {
          districtId: null,
          success: false
        }
      }
    } catch (e) {
          return {
        data: {
          districtId: null,
          success: false
        }
      }
    }
  }

  async getSubscriptions() {
    try {
      const res = await client.query({
        query: GET_SUBSCRIPTIONS,
        fetchPolicy: 'no-cache',
      })

      return {
        data: {          
          subscriptions: res.data.subscriptions,
          success: true,
        },
      }
    } catch (e) {
      return {
        data: {          
          success: false,          
        },
      }
    }
  }

  async getDistrictNameById(districtId) {
    try {
      const { data } = await client.query({
        query: GET_DISTRICT_NAME_BY_ID,
        fetchPolicy: 'no-cache',
        errorPolicy: 'all',
        variables: {
          input: {
            districtId
          }
        }
      })

      const {
        getDistrict
      } = data

      if (getDistrict) {
        return {
          data: {
            ...getDistrict,
            success: true
          }
        }
      }
      return {
        data: {          
          success: false
        }
      }
    } catch (e) {
      return {
        data: {          
          success: false
        }
      }
    }
  }
  
}



// WEBPACK FOOTER //
// ./src/shared/api/http/PortalBffClientHttp.js